import React from "react";
import Table from "react-bootstrap/Table";
import '../../pages/AutomatedDailyReportPage/AutomatedDailyReport.scss';

export default function MonthlyOnlyDailyHeader(props) {

    const {
        currentMonthliesIn,
        spaces
    } = props;

    const totalSpaces = Number.isFinite(Number(spaces)) ? Number(spaces) : 0;
    const currentIn = Number.isFinite(Number(currentMonthliesIn)) ? Number(currentMonthliesIn) : 0;
    const freeSpaces = Math.max(totalSpaces - currentIn, 0);

    return (
        <Table striped bordered className="table-sm header-mobile">
            <thead>
                <tr className="table-warning">
                    <th>Total Spaces</th>
                    <th>Current M In</th>
                    <th>Free Spaces</th>
                    <th>Reserved for Monthlies</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{totalSpaces}</td>
                    <td>{currentIn}</td>
                    <td>{freeSpaces}</td>
                    <td>0</td>
                </tr>
            </tbody>
        </Table>
    );
}
